import { render, staticRenderFns } from "./OrderDatesModal.vue?vue&type=template&id=40533a70&scoped=true&"
import script from "./OrderDatesModal.vue?vue&type=script&lang=js&"
export * from "./OrderDatesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40533a70",
  null
  
)

export default component.exports